<template>
  <el-upload
    action="#"
    list-type="picture-card"
    :auto-upload="false"
    v-model:file-list="fileLists"
    :on-exceed="handleExceed"
    :limit="1"
    :on-change="fileChange"
    accept=".jpg, .png"
    ref="upload"
  >
    <el-icon><Plus /></el-icon>
    <template #file="{ file }">
      <div>
        <img
          id="img"
          class="el-upload-list__item-thumbnail"
          :src="file.url"
          alt=""
        />
        <span class="el-upload-list__item-actions">
          <span
            v-if="!disabled"
            class="el-upload-list__item-delete"
            @click="handleRemove(file)"
          >
            <el-icon><Delete /></el-icon>
          </span>
        </span>
      </div>
    </template>
    <template #tip>
      <div class="el-upload__tip">只能上传jpg/png格式文件且大小不超过 8MB.</div>
    </template>
  </el-upload>
</template>

<script setup>
import { computed, onMounted, ref } from "vue";
import { genFileId } from "element-plus";

const props = defineProps({
  fileList: {
    type: Array,
    default: () => [],
  },
});

const emits = defineEmits(["afterSelect"]);

const upload = ref(null);

const fileLists = computed({
  get() {
    // document.getElementById("img").setAttribute("src", props.fileList[0]);
    return props.fileList;
  },
  set(val) {
    return val;
  },
});

const disabled = ref(false);

const handleRemove = (file) => {
  upload.value?.clearFiles();
  emits("afterSelect", "");
};

const handleExceed = (files) => {
  upload.value?.clearFiles();
  const file = files[0];
  file.uid = genFileId();
  upload.value?.handleStart(file);
};

const fileChange = (val) => {
  emits("afterSelect", val);
};
</script>

<style scoped>
.avatar-uploader {
  border: 1px dashed #8c939d;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}

.avatar-uploader:hover {
  border-color: #409eff;
  color: #409eff;
}

.el-icon.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 178px;
  height: 178px;
  text-align: center;
}
</style>
